export const WIZARD_FORM_KEY = 'wizardForm';
export const WIZARD_UPLOAD_KEY = 'wizardUpload';

export const wizardFormInject = {
  inject: {
    getWizardForm: { from: WIZARD_FORM_KEY },
    uploadFile: { from: WIZARD_UPLOAD_KEY, default: () => () => Promise.resolve(null) },
  },
  computed: {
    form() {
      return this.getWizardForm();
    },
  },
};
